import type { CobaltTagColor } from '@cae/cobalt-react/components/tag';
import type { SubmittedStatus } from '@features/documents/api/types/document.types';

const STATUS_TAG_COLORS: Record<SubmittedStatus, CobaltTagColor> = {
  Submitted: 'yellow',
  InReview: 'blue',
  Completed: 'green',
};

export function getSubmittedStatusTagColor(
  status: SubmittedStatus
): CobaltTagColor {
  return STATUS_TAG_COLORS[status] ?? 'neutral';
}

const STATUS_DISPLAY_LABELS: Record<SubmittedStatus, string> = {
  Submitted: 'Submitted',
  InReview: 'In review',
  Completed: 'Completed',
};

export function getSubmittedStatusLabel(status: SubmittedStatus): string {
  return STATUS_DISPLAY_LABELS[status] ?? status;
}
